/**
 * Organizations ui components enum
 */
export enum OrganizationUIComponents {
	//#region orders
	DefaultOrganizationOrderDetails = 'DefaultOrganizationOrderDetails',
	//#endregion
}
